import { createContext, useContext } from 'react'

// Note: This context is a neutral contract between popupFactory and Overlay.
// popupFactory writes to it (via OverlayControlContext.Provider in PopupProvider).
// Overlay reads from it (via useOverlayControl).
// This keeps Overlay a generic UI component with no direct dependency on popupFactory or its Zustand store.
// Context is used instead of Zustand because it is scoped to a subtree, each Provider wraps exactly one popup instance.
// A Zustand store is global, so simultaneous overlays would overwrite each other's state.

interface OverlayControlContextType {
  isClosing: boolean
  isSuspended: boolean
  hasSuspendedBelow: boolean
  onAfterClose: VoidFunction | undefined
  registerAnimated: VoidFunction | undefined
}

export const OverlayControlContext = createContext<OverlayControlContextType>({
  hasSuspendedBelow: false,
  isClosing: false,
  isSuspended: false,
  onAfterClose: undefined,
  registerAnimated: undefined,
})

export const useOverlayControl = () => useContext(OverlayControlContext)
